import { Modal } from '../../components/Modal';
import { Body, Card, CardButton, Grid, Name, Region } from './LanguagePicker.styles';
import type { LanguagePickerProps } from './LanguagePicker.types';

export function LanguagePicker({ open, onClose, title, closeLabel, items }: LanguagePickerProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      labels={{ close: closeLabel }}
      aboveMobileNav
    >
      <Body>
        <Grid>
          {items.map((item) => (
            <Card key={item.code}>
              <CardButton
                type="button"
                onClick={item.onSelect}
                $active={item.active}
                aria-current={item.active ? 'true' : undefined}
              >
                <Name>{item.name}</Name>
                {item.region && <Region>{item.region}</Region>}
              </CardButton>
            </Card>
          ))}
        </Grid>
      </Body>
    </Modal>
  );
}
